(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/brand-mapping/assets/javascripts/brands/product/yatzy.js') >= 0) return;  svs.modules.push('/components/lb-utils/brand-mapping/assets/javascripts/brands/product/yatzy.js');
"use strict";

let sportProducts;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  sportProducts = trinidad.components.require('lb-utils', 'sport-products').api;
} else {
  sportProducts = svs.components.lbUtils.sportProducts;
}

const {
  productIds,
  getDisplayName,
  getClassName
} = sportProducts;

const model = {
  brand: getClassName(productIds.YATZY),
  displayName: getDisplayName(productIds.YATZY),
  brandLogo: 'yatzy',
  brandMenuColor: 'white'
};

const toExport = model;

if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.lbUtils.brandMapping.brands.product.yatzy', toExport);
}


 })(window);